export default "__VITE_ASSET__DJCGhpfY__"